module.exports = __webpack_public_path__ + "static/media/customer.4e6e1f38.svg";